import { arraysToObject } from './functions';


const dfToObjectList = (df) => {
  return df.values.map(row => arraysToObject(df.columns, row));
};

export { dfToObjectList };